import { useState } from "react";

type GSTSlab = {
  id: string;
  name: string;
  rate: number;
  category: string;
  description: string;
  active: boolean;
};

type TaxRule = {
  id: string;
  name: string;
  state: string;
  baseRate: number;
  surcharge: number;
  effectiveFrom: string;
  active: boolean;
};

const initialSlabs: GSTSlab[] = [
  { id: "gs1", name: "GST 0%",   rate: 0,  category: "Exempt Goods",      description: "Non-precious silver articles (below ₹5000)", active: true  },
  { id: "gs2", name: "GST 3%",   rate: 3,  category: "Precious Metals",   description: "Gold, silver, platinum jewellery & articles",  active: true  },
  { id: "gs3", name: "GST 5%",   rate: 5,  category: "Gemstones",         description: "Cut & polished diamonds, precious stones",     active: true  },
  { id: "gs4", name: "GST 12%",  rate: 12, category: "Imitation Jewels",  description: "Imitation/fashion jewellery",                  active: true  },
  { id: "gs5", name: "GST 18%",  rate: 18, category: "Services",          description: "Making charges / labour charges",              active: true  },
  { id: "gs6", name: "GST 28%",  rate: 28, category: "Luxury",            description: "Luxury watches & accessories (imported)",      active: false },
];

const initialRules: TaxRule[] = [
  { id: "tr1", name: "Maharashtra",    state: "MH", baseRate: 3,  surcharge: 0,   effectiveFrom: "2023-04-01", active: true  },
  { id: "tr2", name: "Delhi",          state: "DL", baseRate: 3,  surcharge: 0,   effectiveFrom: "2023-04-01", active: true  },
  { id: "tr3", name: "Karnataka",      state: "KA", baseRate: 3,  surcharge: 0,   effectiveFrom: "2023-04-01", active: true  },
  { id: "tr4", name: "Tamil Nadu",     state: "TN", baseRate: 3,  surcharge: 0.5, effectiveFrom: "2024-01-01", active: true  },
  { id: "tr5", name: "West Bengal",    state: "WB", baseRate: 3,  surcharge: 0,   effectiveFrom: "2023-04-01", active: false },
  { id: "tr6", name: "Rajasthan",      state: "RJ", baseRate: 3,  surcharge: 0,   effectiveFrom: "2023-04-01", active: true  },
];

const STYLES = `
  .tax-layout { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
  @media(max-width:800px) { .tax-layout { grid-template-columns:1fr; } }

  .tax-card { background:#fff; border:1px solid #f0ebe4; border-radius:16px; box-shadow:0 2px 12px rgba(26,18,8,.07); overflow:hidden; }
  .tax-card-head { display:flex; align-items:center; justify-content:space-between; padding:14px 20px; background:linear-gradient(135deg,#1a1208 0%,#2d1e0f 100%); }
  .tax-card-title { font-size:14px; font-weight:800; color:#fff; display:flex; align-items:center; gap:8px; }
  .tax-add-btn { padding:5px 14px; border-radius:20px; border:1.5px solid rgba(255,255,255,.2); background:rgba(255,255,255,.08); color:#f5c89a; font-size:11px; font-weight:700; cursor:pointer; font-family:inherit; display:flex; align-items:center; gap:5px; }

  .tax-slab-row { display:flex; align-items:center; gap:12px; padding:12px 16px; border-bottom:1px solid #f5f0eb; transition:background .15s; }
  .tax-slab-row:last-child { border-bottom:none; }
  .tax-slab-row:hover { background:#fdf8f3; }
  .tax-rate-bubble { width:48px; height:48px; border-radius:12px; background:linear-gradient(135deg,#1a1208,#2d1e0f); color:#f5c89a; font-size:14px; font-weight:800; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
  .tax-slab-info { flex:1; }
  .tax-slab-name { font-size:13px; font-weight:700; color:#1a1208; }
  .tax-slab-cat  { font-size:11px; font-weight:600; color:#9b8878; margin:2px 0; }
  .tax-slab-desc { font-size:11px; color:#b0a090; }

  .tax-toggle { position:relative; width:36px; height:20px; flex-shrink:0; }
  .tax-toggle input { opacity:0; width:0; height:0; }
  .tax-toggle-slider { position:absolute; inset:0; border-radius:20px; background:#e2e8f0; cursor:pointer; transition:background .2s; }
  .tax-toggle-slider::before { content:""; position:absolute; width:14px; height:14px; left:3px; bottom:3px; background:#fff; border-radius:50%; transition:transform .2s; box-shadow:0 1px 3px rgba(0,0,0,.2); }
  .tax-toggle input:checked + .tax-toggle-slider { background:var(--theme); }
  .tax-toggle input:checked + .tax-toggle-slider::before { transform:translateX(16px); }

  .tax-rule-row { display:flex; align-items:center; gap:10px; padding:10px 16px; border-bottom:1px solid #f5f0eb; }
  .tax-rule-row:last-child { border-bottom:none; }
  .tax-state-badge { background:#f0ebe4; color:#7a6652; font-size:11px; font-weight:800; padding:3px 8px; border-radius:6px; font-family:monospace; flex-shrink:0; }
  .tax-rule-name { flex:1; font-size:13px; font-weight:600; color:#1a1208; }
  .tax-rule-rate { font-size:13px; font-weight:700; color:var(--theme); white-space:nowrap; }
  .tax-rule-date { font-size:11px; color:#9b8878; white-space:nowrap; }

  .tax-modal-overlay { position:fixed; inset:0; background:rgba(26,18,8,.52); backdrop-filter:blur(4px); z-index:1000; display:flex; align-items:center; justify-content:center; padding:24px; animation:tmFadeIn .2s; }
  @keyframes tmFadeIn { from{opacity:0} to{opacity:1} }
  .tax-modal { background:#fff; border-radius:20px; width:100%; max-width:440px; box-shadow:0 24px 64px rgba(26,18,8,.22); animation:tmSlide .25s cubic-bezier(.34,1.56,.64,1); overflow:hidden; }
  @keyframes tmSlide { from{opacity:0;transform:translateY(24px)} to{opacity:1;transform:none} }
  .tax-modal-head { display:flex; justify-content:space-between; align-items:center; padding:18px 22px; background:linear-gradient(135deg,#1a1208,#2d1e0f); }
  .tax-modal-title { font-size:14px; font-weight:800; color:#fff; }
  .tax-modal-close { width:28px; height:28px; border-radius:8px; border:1.5px solid rgba(255,255,255,.15); background:transparent; color:#fff; cursor:pointer; font-size:15px; display:flex; align-items:center; justify-content:center; }
  .tax-modal-body { padding:20px 22px; display:grid; gap:12px; }
  .tax-field { display:flex; flex-direction:column; gap:4px; }
  .tax-label { font-size:11px; font-weight:700; color:#7a6652; text-transform:uppercase; letter-spacing:.6px; }
  .tax-input { padding:9px 12px; border:1.5px solid #ede6df; border-radius:10px; font-size:13px; color:#1a1208; font-family:inherit; outline:none; background:#fdf8f3; transition:border .2s; }
  .tax-input:focus { border-color:var(--theme); background:#fff; }
  .tax-modal-foot { padding:12px 22px; border-top:1.5px solid #f0ebe4; display:flex; justify-content:flex-end; gap:8px; background:#fdf8f3; }
  .tax-btn-cancel { padding:8px 16px; border-radius:10px; border:1.5px solid #ede6df; background:#fff; font-size:13px; font-weight:600; color:#7a6652; cursor:pointer; font-family:inherit; }
  .tax-btn-save { padding:8px 18px; border-radius:10px; border:none; background:linear-gradient(135deg,#d4551a,var(--theme)); color:#fff; font-size:13px; font-weight:700; cursor:pointer; font-family:inherit; }

  .tax-info-banner { background:linear-gradient(135deg,#fff7ed,#fef3c7); border:1px solid #fed7aa; border-radius:12px; padding:12px 16px; font-size:12px; color:#92400e; display:flex; gap:10px; align-items:flex-start; }
`;

const emptyForm = () => ({ name: "", rate: "", category: "", description: "" });

export function TaxPage() {
  const [slabs, setSlabs] = useState<GSTSlab[]>(initialSlabs);
  const [rules, setRules] = useState<TaxRule[]>(initialRules);
  const [showModal, setShowModal] = useState(false);
  const [form, setForm] = useState(emptyForm());

  function toggleSlab(id: string) {
    setSlabs(prev => prev.map(s => s.id === id ? { ...s, active: !s.active } : s));
  }
  function toggleRule(id: string) {
    setRules(prev => prev.map(r => r.id === id ? { ...r, active: !r.active } : r));
  }
  function addSlab() {
    if (!form.name || !form.rate || !form.category) return;
    setSlabs(prev => [...prev, {
      id: `gs${Date.now()}`,
      name: form.name,
      rate: Number(form.rate),
      category: form.category,
      description: form.description,
      active: true,
    }]);
    setForm(emptyForm());
    setShowModal(false);
  }

  return (
    <div className="d-grid gap-3">
      <style>{STYLES}</style>

      <div className="tax-info-banner">
        <i className="bi bi-info-circle-fill" style={{ fontSize: 16, flexShrink: 0, marginTop: 1 }}></i>
        <div>
          <strong>GST on Jewellery (India):</strong> Precious metal jewellery (gold/silver/platinum) attracts 3% GST. Diamonds & precious stones attract 5%. Making charges are taxed at 5%. Imitation jewellery at 12%. These rates are as per the latest GST Council notifications.
        </div>
      </div>

      <div className="tax-layout">
        {/* GST Slabs */}
        <div className="tax-card">
          <div className="tax-card-head">
            <div className="tax-card-title"><i className="bi bi-percent"></i> GST Slabs</div>
            <button className="tax-add-btn" onClick={() => setShowModal(true)}>
              <i className="bi bi-plus-lg"></i> Add Slab
            </button>
          </div>
          <div>
            {slabs.map(s => (
              <div key={s.id} className="tax-slab-row">
                <div className="tax-rate-bubble">{s.rate}%</div>
                <div className="tax-slab-info">
                  <div className="tax-slab-name">{s.name}</div>
                  <div className="tax-slab-cat">{s.category}</div>
                  <div className="tax-slab-desc">{s.description}</div>
                </div>
                <label className="tax-toggle">
                  <input type="checkbox" checked={s.active} onChange={() => toggleSlab(s.id)} />
                  <span className="tax-toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        </div>

        {/* State-wise Tax Rules */}
        <div className="tax-card">
          <div className="tax-card-head">
            <div className="tax-card-title"><i className="bi bi-map"></i> State Tax Rules</div>
          </div>
          <div>
            {rules.map(r => (
              <div key={r.id} className="tax-rule-row">
                <div className="tax-state-badge">{r.state}</div>
                <div className="tax-rule-name">{r.name}</div>
                <div style={{ textAlign: "right" }}>
                  <div className="tax-rule-rate">{r.baseRate + r.surcharge}% GST{r.surcharge > 0 && <span style={{ fontSize: 10, color: "#9b8878" }}> (+{r.surcharge}% sur.)</span>}</div>
                  <div className="tax-rule-date">From {r.effectiveFrom}</div>
                </div>
                <label className="tax-toggle">
                  <input type="checkbox" checked={r.active} onChange={() => toggleRule(r.id)} />
                  <span className="tax-toggle-slider"></span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Add Slab Modal */}
      {showModal && (
        <div className="tax-modal-overlay" onClick={() => setShowModal(false)}>
          <div className="tax-modal" onClick={e => e.stopPropagation()}>
            <div className="tax-modal-head">
              <div className="tax-modal-title">Add GST Slab</div>
              <button className="tax-modal-close" onClick={() => setShowModal(false)}>✕</button>
            </div>
            <div className="tax-modal-body">
              {[
                { label: "Slab Name",   key: "name",        placeholder: "e.g. GST 3%" },
                { label: "GST Rate (%)",key: "rate",        placeholder: "e.g. 3",      type: "number" },
                { label: "Category",   key: "category",    placeholder: "e.g. Precious Metals" },
                { label: "Description",key: "description", placeholder: "Short note..." },
              ].map(f => (
                <div key={f.key} className="tax-field">
                  <div className="tax-label">{f.label}</div>
                  <input
                    className="tax-input"
                    type={f.type || "text"}
                    placeholder={f.placeholder}
                    value={(form as any)[f.key]}
                    onChange={e => setForm(prev => ({ ...prev, [f.key]: e.target.value }))}
                  />
                </div>
              ))}
            </div>
            <div className="tax-modal-foot">
              <button className="tax-btn-cancel" onClick={() => setShowModal(false)}>Cancel</button>
              <button className="tax-btn-save" onClick={addSlab}><i className="bi bi-plus-lg"></i> Add Slab</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
